import { contactConfig } from './siteConfig'

export type Faq = {
  q: string
  a: string
}

export const faqs: Faq[] = [
  {
    q: '¿Cómo lo recibo?',
    a: 'Apenas se acredita el pago te llega un mail con el enlace de descarga, normalmente en minutos. Si no lo ves, revisá spam o escribinos por WhatsApp.',
  },
  {
    q: '¿Es físico o digital?',
    a: 'Digital (PDF). No hay envío ni esperas: lo descargás y lo imprimís cuando quieras.',
  },
  {
    q: '¿Puedo imprimirlo?',
    a: 'Sí, está diseñado para A4, en casa o en fotocopiadora, las veces que necesites.',
  },
  {
    q: '¿Necesito ser profesional de la salud?',
    a: 'No. Está pensado para hijos, nietos y cuidadores, con instrucciones simples en cada página.',
  },
  {
    q: '¿Sirve si tiene movilidad reducida?',
    a: 'Sí. El Nivel 1 incluye ejercicios en silla o en cama. Si hay antecedentes de caídas o alguna condición médica, consultá antes con su médico.',
  },
  {
    q: '¿Y si no lo usa todos los días?',
    a: 'No pasa nada. Lo retoman cuando puedan.',
  },
  {
    q: '¿Qué medios de pago aceptan?',
    a: 'Mercado Pago: tarjeta de crédito, débito o dinero en cuenta.',
  },
  {
    q: '¿Tiene garantía?',
    a: 'Sí, 7 días. Si no te sirve, te devolvemos todo.',
  },
  {
    q: '¿Y si tengo un problema con la descarga?',
    a: `Escribinos al WhatsApp ${contactConfig.whatsappNumber} y te responde una persona, no un bot.`,
  },
]
